"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkboxStyles = exports.labelStyles = void 0;

var _reactEmotion = require("react-emotion");

var _styleConsts = require("../utils/styleConsts");

var antCheckboxEffect =
/*#__PURE__*/
(0, _reactEmotion.keyframes)("0%{-webkit-transform:scale(1);transform:scale(1);opacity:0.5;}100%{-webkit-transform:scale(1.6);transform:scale(1.6);opacity:0;}");

var labelStyles = function labelStyles(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:inline-flex;align-items:center;font-size:", _styleConsts.font.size.large, ";font-weight:400;line-height:17px;color:", theme.color.text, ";align-items:center;cursor:pointer;fill:", theme.color.white, ";stroke:", theme.color.white, ";&:hover div{border:1px solid ", theme.color.accent, ";}input{", _styleConsts.screenReaderOnly, "}input:checked ~ span{color:", theme.color.text, ";}input:checked ~ div{border-color:", theme.color.accent, ";background-color:", theme.color.accent, ";position:relative;}input:checked ~ div:after{position:absolute;top:0;left:0;width:100%;height:100%;border-radius:2px;border:1px solid #1890ff;content:'';-webkit-animation:", antCheckboxEffect, " 0.36s ease-in-out;animation:", antCheckboxEffect, " 0.36s ease-in-out;-webkit-animation-fill-mode:both;animation-fill-mode:both;visibility:visible;box-sizing:border-box;}input:disabled ~ span{opacity:", theme.disabledOpacity, ";color:", theme.color.black3, ";cursor:not-allowed;}input:disabled ~ div{opacity:", theme.disabledOpacity, ";border:1px solid ", theme.color.black3, ";cursor:not-allowed;}")
  );
};

exports.labelStyles = labelStyles;

var checkboxStyles = function checkboxStyles(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("display:inline-flex;justify-content:center;align-items:center;box-sizing:border-box;width:18px;height:18px;min-width:18px;min-height:18px;margin-right:16px;text-align:center;border:1px solid ", theme.color.black3, ";border-radius:", _styleConsts.borderRadius, ";background-color:", theme.color.white, ";transition:background-color 0.25s,border-color 0.25s;")
  );
};

exports.checkboxStyles = checkboxStyles;